import { createContext, useContext } from "react"
import type { TabsRootOrientation } from "@base-ui/react/tabs"

// =============================================================================
// Context
// =============================================================================

export const TabsOrientationContext =
  createContext<TabsRootOrientation>("horizontal")

export function useTabsOrientation(): TabsRootOrientation {
  return useContext(TabsOrientationContext)
}
